'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionsController = function () {
    function SelectionsController($scope, $rootScope, ApiSelections, $ionicLoading, $q, $ionicScrollDelegate) {
        _classCallCheck(this, SelectionsController);

        this.ApiSelections = ApiSelections;
        this.$ionicLoading = $ionicLoading;
        this.selections = [];
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.isFilterApplied = false;

        this.selectionsPromise = $q.defer();
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    _createClass(SelectionsController, [{
        key: 'init',
        value: function init(assignedPackageFilter, pullToRefresh) {
            var _this = this;

            if (!pullToRefresh) {
                this.$ionicLoading.show({
                    template: '<spinner-advinda></spinner-advinda>'
                });
            }

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
                duration: 1000
            });

            var teaserPackageFilter = {};
            teaserPackageFilter.teaserPackage = true;
            this.ApiSelections.getSelectionsFiltered(teaserPackageFilter).then(function (res) {
                _this.teaserPackages = res;
            }).catch(function () {
                _this.$ionicLoading.hide();
                _this.$scope.$broadcast('scroll.refreshComplete');
            });

            assignedPackageFilter.teaserPackage = false;
            this.ApiSelections.getSelectionsFiltered(assignedPackageFilter).then(function (res) {
                _this.selections = res;
                _this.selectionsPromise.resolve(res);
            }).catch(function () {
                _this.$ionicLoading.hide();
                _this.$scope.$broadcast('scroll.refreshComplete');
            });

            this.ApiSelections.getPurchasedTeamSelections().then(function (res) {
                _this.selectionsPurchased = res;
                _this.selections.loaded = true;
                _this.$ionicLoading.hide();
                _this.$scope.$broadcast('scroll.refreshComplete');
            }).catch(function () {
                _this.$ionicLoading.hide();
                _this.$scope.$broadcast('scroll.refreshComplete');
            });
        }
    }, {
        key: 'setSearchPerformedSignal',
        value: function setSearchPerformedSignal() {

            this.$ionicScrollDelegate.scrollTop();
            this.$rootScope.$broadcast('searchPerformed');
        }
    }]);

    return SelectionsController;
}();

exports.default = SelectionsController;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selections.controller.js
 **/